
const getCheckpointsAsLaps = (checkpoints) =>
	Array.isArray(checkpoints)
		? checkpoints.filter(cp => !!(cp.options && cp.options.asLap))
		: [];

export {
	getCheckpointsAsLaps
};